
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/search",
      function () {
        return require("private-next-pages/jobs/search/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/search"])
      });
    }
  